export const TrueValues = new Set(['True', 'TRUE', 'true', '1', 1, 'yes', 'Yes', 'YES', 't', 'T']);
export const FalseValues = new Set(['False', 'FALSE', 'false', '0', 0, 'no', 'No', 'NO', '', '-', 'N/A', 'f', 'F']);

const knownBoolFormats = new Set([...TrueValues, ...FalseValues, 1, 0]);

export const parseBool = (value: any): boolean | undefined | null => {
    if (typeof value === 'undefined' || value === null) {
        return value;
    }

    if (typeof value === 'boolean') {
        return value;
    }

    if (!knownBoolFormats.has(value)) {
        throw new Error(`Invalid boolean value: '${value}', type: ${typeof value}`);
    }

    return TrueValues.has(value);
};
